export const FUNCTIONS_ERROR_CODE_KEYS = {
  ok: null,
  cancelled: null,
  unknown: null,
  "invalid-argument": null,
  "deadline-exceeded": null,
  "not-found": null,
  "already-exists": null,
  "permission-denied": null,
  "resource-exhausted": null,
  "failed-precondition": null,
  aborted: null,
  "out-of-range": null,
  unimplemented: null,
  internal: null,
  unavailable: null,
  "data-loss": null,
  unauthenticated: null,
} as const;

export type FunctionsErrorCode = keyof typeof FUNCTIONS_ERROR_CODE_KEYS;